export default "__VITE_ASSET__CCbo0X7s__"